import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import { Close, Save } from '@material-ui/icons'
import redux from '../redux/index.js'
import { cleanFileName } from '../util.js'
import {
  CONTENT_BACKGROUND,
  FOOTER_BACKGROUND,
  FOOTER_HEIGHT,
  HEADER_BACKGROUND,
  HEADER_HEIGHT
} from '../styles.js'

const FolderDialog = ({ strings, selected, item, onCreateFolder, onHideCreateDialog }) => {
  const [name, setName] = useState('')
  const trimmedName = String(name || '').trim()
  const disableSave = trimmedName.length === 0

  const onConfirm = () => {
    if (!disableSave) {
      onCreateFolder(selected, item, trimmedName)
    }
  }

  return (
    <Dialog fullScreen open>
      <DialogTitle style={titleStyle}>
        <div style={titleContentStyle}>{strings.create_folder}</div>
      </DialogTitle>
      <DialogContent style={contentStyle}>
        <input
          autoFocus
          type='text'
          placeholder={strings.foldername}
          value={name}
          style={inputStyle}
          onChange={(e) => setName(cleanFileName(e.target.value))}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !disableSave) {
              e.preventDefault()
              onConfirm()
            }
          }}
        />
      </DialogContent>
      <DialogActions style={actionsStyle}>
        <Button onClick={onHideCreateDialog} style={actionButtonStyle()}>
          <Close style={actionIconStyle} />{strings.cancel}
        </Button>
        <Button
          disabled={disableSave}
          onClick={onConfirm}
          style={actionButtonStyle(disableSave)}
        >
          <Save style={actionIconStyle} />{strings.create_folder}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const inputStyle = {
  width: '100%',
  maxWidth: 520,
  padding: '10px 12px',
  borderRadius: 4,
  border: '1px solid #c7cdd1',
  fontSize: '1rem',
  background: 'white',
  boxSizing: 'border-box'
}

const titleStyle = {
  background: HEADER_BACKGROUND,
  color: 'white',
  padding: '0px 19px',
  fontSize: '20px',
  height: HEADER_HEIGHT
}

const titleContentStyle = {
  marginTop: '8px'
}

const contentStyle = {
  background: CONTENT_BACKGROUND,
  padding: '20px 16px'
}

const actionsStyle = {
  borderTop: '1px solid white',
  background: FOOTER_BACKGROUND,
  height: FOOTER_HEIGHT,
  padding: 0
}

const actionButtonStyle = (disabled = false) => {
  return {
    color: disabled ? '#aaafb2' : 'white',
    textTransform: 'none',
    marginRight: '10px'
  }
}

export const actionIconStyle = {
  marginRight: '5px'
}

const mapStateToProps = (state) => {
  const selected = state.selected.current
  const item = state.dialog.meta.item
  return {
    selected,
    item,
    strings: state.locale.strings
  }
}

const mapDispatchToProps = (dispatch) => {
  const { dialog, files } = redux.actions
  return {
    onHideCreateDialog: () => {
      dispatch(dialog.hideDialog())
    },
    onCreateFolder: (siteItem, item, name) => {
      dispatch(files.createFolder(siteItem, item, name))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FolderDialog)
